import { Controller } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
// import moment from "moment-business-days";

class ManagerBase extends Controller {
	constructor (name) {
		super(name);

		this.remoteClassName = "";
	}

	getListByGuidList (guidList, filters) {
		const rd = NousCore.api.createRequest({ filters, item: {guidList} });
		const requestedAction = "get-list-by-guid-list";

		// if (filters) {
		// 	rd.filters = filters;
		// }

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:

						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data: null,
							error: data.error,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	save (item) {
		const rd = NousCore.api.createRequest({ item: item.export() });
		const requestedAction = item.guid === "" ? "insert" : "update";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						item.import(data.items[0]);
						item.clean();
						return {
							data: item,
							requestedAction,
							status: "ok",
						};
					case 9:
					case 99:
						return {
							data,
							errors: data.errors,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async setStatusAutomatic (item) {
		const rd = NousCore.api.createRequest({ item: { guid: item.guid } });
		const requestedAction = "set-status-automatic";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: item,
							requestedAction,
							status: "ok",
						};
					case 9:
					case 99:
						return {
							data,
							errors: data.errors,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}
}
	
export default ManagerBase;
